function Practice() {
    return(
        <div style={{backgroundColor:"yellow",  width: "100%", height: "200px",overflow: "auto",
            marginTop: "250px"}}>
                <div style={{backgroundColor:"pink", height : "60px",}} ></div>
            </div>
            
    )

}
export default Practice;